import React from "react";
import { Route, Routes } from "react-router";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
// import {
//   createBrowserRouter,
//   createRoutesFromElements,
//   Route,
//   RouterProvider,
// } from "react-router-dom";

import SnackBar from "../components/SnackBar";
import Table from "./Table";
import TopicDetail from "./TopicDetail";
import OpinionDetail from "./OpinionDetail";
import DiscussionDetail from "./DiscussionDetail";
import Profile from "./Profile";
import Comment from "./Comment";
import GptComment from "./GptComment";
import Main from "./Main";
import FooterNav from "../components/FooterNav/index";
import Explore from "./Explore";
import EditProfile from "./Profile/EditProfile";
import EditProfilePicture from "./Profile/EditProfile/EditProfilePicture/index";
import Login from "./Login/Main";
import EditName from "./Login/Edit/Name";
import EditAvatar from "./Login/Edit/Avatar";
import EditCategory from "./Login/Edit/Category";
import AlertDialog from "../components/AlertDialog";
import SetLoginToken from "../components/SetLoginToken";
import { getSettingState } from "../../redux/features/settingSlice";
import DynamicThemeBar from "../components/DynamicThemeBar";
import UnderConstruction from "./UnderConstruction/index";
import Error404 from "./Error404";
import About from "./About/index";
import ModalList from "../components/ModalList";
import RotateScreen from "../components/RotateScreen";
import Notifications from "./Notifications";
import Terms from "./Terms";
import ShortLink from "./ShortLink";
import Application from "./Application";
import AddPost from "./AddPost/index";

const Routing = () => {
  const { userData } = useSelector(getSettingState);

  return (
    <Box id='index-temp' className='index-temp'>
      <Routes>
        <Route path='*' element={<Error404 />} />
        <Route path='/' element={<Main />} />
        <Route path='/ls' element={<ShortLink />} />
        <Route path='/table/:tableId' element={<Table />} />
        <Route
          path='/table/:tableId/opinions/:opinionId'
          element={<OpinionDetail />}
        />
        <Route
          path='/table/:tableId/opinions/:opinionId/topics/:topicId'
          element={<TopicDetail />}
        />
        <Route
          path='/table/:tableId/discussions/:discussionId'
          element={<DiscussionDetail />}
        />
        <Route
          path='/table/:tableId/discussions/:discussionId/topics/:topicId'
          element={<TopicDetail />}
        />
        {/* {userData && ( */}
          <Route
            path='/table/:tableId/opinions/:discussionId/addpost'
            element={<AddPost />}
          />
        {/* )} */}
        <Route
          caseSensitive
          path='/underconstruction'
          element={<UnderConstruction />}
        />
        <Route caseSensitive path='/application' element={<Application />} />
        <Route caseSensitive path='/about' element={<About />} />
        <Route caseSensitive path='/terms' element={<Terms />} />
        <Route path='/profile/' element={<Profile />} />
        <Route path='/profile/:profileId' element={<Profile />} />
        {userData && (
          <Route path='/profile/:profileId/comment' element={<GptComment />} />
        )}
        {userData && (
          <>
            <Route path='/profile/editprofile' element={<EditProfile />} />
            <Route
              path='/profile/editprofile/profilepicture'
              element={<EditProfilePicture />}
            />
          </>
        )}
        <Route path='/table/:tableId/comment/' element={<Comment />} />
        <Route
          path='/table/:tableId/discussions/:discussionId/topics/:topicId/comment/'
          element={<Comment />}
        />
        <Route
          path='/table/:tableId/opinions/:opinionId/topics/:topicId/comment/'
          element={<Comment />}
        />
        {userData && (
          <Route path='/notification/' element={<Notifications />} />
        )}
        <Route path='/explore' element={<Explore />} />
        {!userData && <Route path='/login' element={<Login />} />}
        {userData && (
          <>
            <Route path='/login/editname' element={<EditName />} />
            <Route path='/login/editavatar' element={<EditAvatar />} />
            <Route path='/login/editcategory' element={<EditCategory />} />
          </>
        )}
      </Routes>

      <RotateScreen />
      <DynamicThemeBar />
      <SetLoginToken />
      <ModalList />
      <AlertDialog />
      <SnackBar />
      <FooterNav />
    </Box>
  );
};

export default Routing;
